module.exports = __webpack_public_path__ + "92a7f3dd93ecd0bca09e036290cccdd3.png";